import { ReactNode } from 'react'
import { FacetGroupName, FacetGroupStatus } from '../../__generated__/fed-graphql-types'

export interface ExpandableGroup {
    status: FacetGroupStatus | null
    selectedValuesSummary: string | null
    title: string | null
    expandableGroupName: ExpandableGroupName
    helpText?: ReadonlyArray<string> | undefined
    clearButtonLabel?: string | null
}

export enum SortGroupName {
    sort = 'sort',
}

export type ExpandableGroupName = FacetGroupName | SortGroupName

export interface ExpandableFilterProps {
    icon?: ReactNode
    title?: string
    group?: ExpandableGroup
    children?: ReactNode
    singularColumn?: boolean
    badge?: ReactNode
    alwaysOpen?: boolean
}
